import React, { useState } from "react";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";

import Table from "../../Common/Table";
import Row from "../../Common/Row";
import Confirmation from "../../Common/Modals/Confirmation";
import Vehicle from "../../../services/vehicle";

import Actions from "../../../store/actions/vehicleActions";

const Rows = () => {
	const dispatch = useDispatch();
	const vehicleData = useSelector(state => state.vehicle);
	const vehicle = {...vehicleData.cp, ...vehicleData.uio, ...vehicleData.connected};
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [actionInProgress, setActionInProgress] = useState(false);
	const showDelete = !_.get(vehicle, `hasAutomaticMMRegistration`, false);

	async function deleteDevice() {
        setModalIsOpen(false);
		if (!actionInProgress) {
			setActionInProgress(true);
			await Vehicle.deleteDevice(vehicle.vin);
			dispatch(Actions.deleteDevice());
			setActionInProgress(false);
		}
	}
	return (
		<>
			<Row label={`ID`} value={vehicle.id} />
			<Row label={`VIN`} value={vehicle.vin} />
			<Row label={`Brand`} value={vehicle.brand} />
			<Row label={`Multimedia Device ID`} value={_.get(vehicle, `device.id`)}>
				{
					_.has(vehicle, `device.id`) && showDelete &&
					<div className=" pull-right">
						<button
							className="btn-sm btn-calculation"
							onClick={() => {
								setModalIsOpen(true);
							}}
							disabled={actionInProgress}
						>
							<span className="fa fa-remove" aria-hidden="true" /> Delete device
					</button>
					</div>
				}
			</Row>
			{vehicle.dcmType && <Row label={`DCM type`} value={vehicle.dcmType}/>}
			{vehicle.licencePlate && <Row label={`License plate`} value={vehicle.licencePlate} />}
			{vehicle.model && <Row label={`Model`} value={vehicle.model} />}
			{vehicle.engine && <Row label={`Engine`} value={vehicle.engine} />}
			{vehicle.transmission && <Row label={`Transmission`} value={vehicle.transmission} />}
			{vehicle.year && <Row label={`Year`} value={vehicle.year} />}
			<Confirmation
				modalIsOpen={modalIsOpen}
				setModalIsOpen={setModalIsOpen}
				title={`Delete device association`}
				message={`Are you sure you want to delete the device association to the customer?`}
				onAccept={deleteDevice}
				onDecline={() => {
					setModalIsOpen(false);
				}}
			>
				<span>
					This action is <strong>not reversible</strong>!
				</span>
			</Confirmation>
		</>
	);
};

const Details = () => {
	return (
		<div className="row">
			<div className="col-xs-12">
				<Table
					title={`General details`}
				>
					<Rows />
				</Table>
			</div>
		</div>
	);
};
Details.displayName = `Details`;

Rows.displayName = `Rows`;

export default Details;
